/* eslint-disable react-hooks/exhaustive-deps */
import "./FilterModal.css"
import { Modal, Select } from '@sede-enterprise/shell-ds-react-framework'
import React, { useEffect, useState } from 'react'
import {fetchFilterData} from "../../api/homeApi"
import { FilterSensorLogic, useFilterSensorState, useUpdatedFilterValues } from "./FilterSensorLogic";
import { toast } from "react-toastify";
import { getNextAvailableFilter, getUniqueValues, isAnyFilterSelected, buildOptionsFilterStr, getAllOptions } from "../../util/helperFunctions";

const BASE_FILTER = `sensor.excludeFromUi = 0`;
const CANCUI_BASE_FILTER = `sensor.isCancui = 1`


const FilterModal = ({ open, onClose, handleFilterChange, handleFilterClear, filterKey, isModel = false, isCancui = false }) => {

    const [noFilter, setNoFilter] = useState(true);

    const [unitOptions, setUnitOptions] = useState([]);
    const [loadingUnit, setLoadingUnit] = useState(false);

    const [siteOptions, setSiteOptions] = useState([]);
    const [loadingSite, setLoadingSite] = useState(false);

    const [equipmentOptions, setEquipmentOptions] = useState([]);
    const [loadingEquipment, setLoadingEquipment] = useState(false);

    const [productionUnitOptions, setProductionUnitOptions] = useState([]);
    const [loadingProductionUnit, setLoadingProductionUnit] = useState(false);

    const [corrosionLoopOptions, setcorrosionLoopOptions] = useState([]);
    const [loadingCorrosionLoop, setLoadingCorrosionLoop] = useState(false);

    const [positionOptions, setpositionOptions] = useState([]);
    const [loadingPosition, setLoadingPosition] = useState(false);

    const [materialOptions, setMaterialOptions] = useState([]);
    const [loadingMaterial, setLoadingMaterial] = useState(false);

    const [fluid, setFluid] = useState([]);
    const [loadingFluid, setLoadingFluid] = useState(false);

    const [cmlOptions, setcmlOptions] = useState([]);
    const [loadingCml, setLoadingCml] = useState(false);

    const [filterFormValues, updateFilters] = useFilterSensorState(filterKey);

    useEffect(() => {
        if (noFilter) {

            setLoadingSite(true);
            setLoadingProductionUnit(true);
            setLoadingUnit(true);
            setLoadingEquipment(true);
            setLoadingFluid(true);
            setLoadingMaterial(true);
            setLoadingPosition(true);
            setLoadingCml(true);
            setLoadingCorrosionLoop(true);


            const fetchData = async () => {
                  try {
                    const base_filter = isCancui ? CANCUI_BASE_FILTER : BASE_FILTER;
                    const response = await fetchFilterData(base_filter);
                    const { siteOptions, productionUnitOptions, unitOptions, equipmentOptions, cmlOptions } = getAllOptions(response)
                    const uniqueCorrosionLoops = getUniqueValues(response, "corrosionLoop");
                    const uniqueFluids = getUniqueValues(response, "fluid");
                    const uniqueMaterials = getUniqueValues(response, "material");
                    const uniquePositions = getUniqueValues(response, "position");
                    
                    setSiteOptions(siteOptions);
                    setLoadingSite(false);

                    setProductionUnitOptions(productionUnitOptions);
                    setLoadingProductionUnit(false);
                    
                    setUnitOptions(unitOptions);
                    setLoadingUnit(false);

                    setEquipmentOptions(equipmentOptions);
                    setLoadingEquipment(false);

                    setcmlOptions(cmlOptions);
                    setLoadingCml(false);

                    setcorrosionLoopOptions(uniqueCorrosionLoops);
                    setLoadingCorrosionLoop(false);

                    setFluid(uniqueFluids);
                    setLoadingFluid(false);

                    setMaterialOptions(uniqueMaterials);
                    setLoadingMaterial(false);

                    setpositionOptions(uniquePositions);
                    setLoadingPosition(false);



                  } catch (err) {
                    toast.error("Cannot fetch filter options");
                    //setError(err);
                  } finally {
                    setNoFilter(false);
                  }
                };
            fetchData();
            
        }

    }, [
        setUnitOptions,
        setProductionUnitOptions,
        setEquipmentOptions,
        setSiteOptions,
        setFluid,
        setMaterialOptions,
        setpositionOptions,
        setcmlOptions,
        setcorrosionLoopOptions,
        noFilter
    ]);

    const improveProdUnit = (data) => {
        const {productionUnitOptions} = getAllOptions(data, 'productionUnit');
        setProductionUnitOptions(productionUnitOptions);
    }

    const improveUnit = (data) => {
        const {unitOptions} = getAllOptions(data, 'unit');
        //console.log(unitOptions)
        setUnitOptions(unitOptions);
    }

    const improveEquipment = (data) => {
        const {equipmentOptions} = getAllOptions(data, 'equipment');
        setEquipmentOptions(equipmentOptions);
    }

    const improveCml = (data) => {
        const {cmlOptions} = getAllOptions(data, 'conditionMonitoringLocation');
        console.log("cml options",cmlOptions)
        setcmlOptions(cmlOptions);
    }

    const improvefluid = (data) => {
        //console.log("fluid data",data.fluid)
        const fluidValue = getUniqueValues(data, "fluid");
        setFluid(fluidValue);
    }

    const improvePosition = (data) => {
        const positionValue = getUniqueValues(data, 'position');
        setpositionOptions(positionValue);
    }

    const improveMaterial = (data) => {
        const materialValue = getUniqueValues(data, 'material');
        setMaterialOptions(materialValue);
    }

    const improveCorrosionLoop = (data) => {
        const corrosionLoopValues = getUniqueValues(data, 'corrosionLoop');
        setcorrosionLoopOptions(corrosionLoopValues);
    }

    const improveFilter = ({ type, value }) => {
        const base_filter = isCancui ? CANCUI_BASE_FILTER : BASE_FILTER;
        setNoFilter(false);
        if ([].concat(...Object.values(filterFormValues)).length === 1 && value.length === 0) {
            setNoFilter(true);
            return;
        }
        if (value.length === 0) {
            // If the current filter is empty, get the options based on the next available filter above
            const nextAvailableFilter = getNextAvailableFilter(type, filterFormValues);
            if (nextAvailableFilter) {
                const nextAvailableFilterValue = filterFormValues[nextAvailableFilter];
                improveFilter({ type: nextAvailableFilter, value: nextAvailableFilterValue });
                return;
            }
            setNoFilter(true);
            return;
        }
        if (type === 'unit') {

            setLoadingEquipment(true);
            setLoadingCml(true);
            setLoadingFluid(true);
            setLoadingMaterial(true);
            setLoadingPosition(true);
            setLoadingCorrosionLoop(true);
            fetchFilterData(`sensor.unit IN (${buildOptionsFilterStr(value)}) AND ${base_filter}`).then((data) => {
                if (data && data.length) {
                    improveEquipment(data)
                    improveCml(data)
                    improvefluid(data);
                    improveMaterial(data);
                    improvePosition(data);
                    improveCorrosionLoop(data);
                } else {
                    setFluid([]);
                    setMaterialOptions([]);
                    setpositionOptions([]);
                    setEquipmentOptions([]);
                    setcmlOptions([]);
                    setcorrosionLoopOptions([]);
                }
                setLoadingFluid(false);
                setLoadingMaterial(false);
                setLoadingPosition(false);
                setLoadingCorrosionLoop(false);
                setLoadingEquipment(false);
                setLoadingCml(false);
            });
        }

        if (type === 'equipment') {

            setLoadingCml(true);
            setLoadingFluid(true);
            setLoadingMaterial(true);
            setLoadingPosition(true);
            setLoadingCorrosionLoop(true);
            fetchFilterData(`sensor.equipment IN (${buildOptionsFilterStr(value)}) AND ${base_filter}`).then((data) => {
                if (data && data.length > 0) {
                    improvefluid(data);
                    improveMaterial(data);
                    improvePosition(data);
                    improveCml(data)
                    improveCorrosionLoop(data);
                } else {
                    setcmlOptions([]);
                    setFluid([]);
                    setMaterialOptions([]);
                    setpositionOptions([]);

                }
                setLoadingCml(false);
                setLoadingCorrosionLoop(false);
                setLoadingFluid(false);
                setLoadingMaterial(false);
                setLoadingPosition(false);
            });
        }

        if (type === 'cml') {

            setLoadingFluid(true);
            setLoadingMaterial(true);
            setLoadingPosition(true);
            fetchFilterData(`sensor.conditionMonitoringLocation IN (${buildOptionsFilterStr(value)}) AND ${BASE_FILTER}`).then((data) => {
                if (data && data.length) {
                    improvefluid(data);
                    improveMaterial(data);
                    improvePosition(data);
                } else {
                    setFluid([]);
                    setMaterialOptions([]);
                    setpositionOptions([]);
                }
                setLoadingFluid(false);
                setLoadingMaterial(false);
                setLoadingPosition(false);
            });
        }

        if (type === 'productionUnit') {
            setLoadingUnit(true);
            setLoadingEquipment(true);
            setLoadingCml(true);
            setLoadingFluid(true);
            setLoadingMaterial(true);
            setLoadingPosition(true);
            setLoadingCorrosionLoop(true);
            fetchFilterData(`sensor.productionUnit IN (${buildOptionsFilterStr(value)}) AND ${base_filter}`).then((data) => {
                if (data && data.length) {
                    improveUnit(data)
                    improveEquipment(data)
                    improveCml(data)
                    improvefluid(data);
                    improveMaterial(data);
                    improvePosition(data);
                    improveCorrosionLoop(data);
                } else {
                    setFluid([]);
                    setMaterialOptions([]);
                    setpositionOptions([]);
                    setUnitOptions([]);
                    setEquipmentOptions([]);
                    setcmlOptions([]);
                    setcorrosionLoopOptions([]);
                }
                setLoadingFluid(false);
                setLoadingMaterial(false);
                setLoadingPosition(false);
                setLoadingCorrosionLoop(false);
                setLoadingUnit(false);
                setLoadingEquipment(false);
                setLoadingCml(false);
            });
        }

        if (type === 'fluid') {
            setLoadingMaterial(true);
            setLoadingPosition(true);
            fetchFilterData(`nominals.fluid IN (${buildOptionsFilterStr(value)}) AND ${BASE_FILTER}`).then((data) => {
                if (data && data.length > 0) {
                    improveMaterial(data);
                    improvePosition(data);
                } else {
                    setMaterialOptions([]);
                    setpositionOptions([]);
                }
                setLoadingMaterial(false);
                setLoadingPosition(false);
            });
        }

        if (type === 'site') {
            setLoadingProductionUnit(true);
            setLoadingUnit(true);
            setLoadingEquipment(true);
            setLoadingCorrosionLoop(true);
            setLoadingCml(true);
            setLoadingFluid(true);
            setLoadingMaterial(true);
            setLoadingPosition(true);
            fetchFilterData(`sensor.site IN (${buildOptionsFilterStr(value)}) AND ${base_filter}`).then((data) => {
                
                if (data && data.length > 0) {
                    improvefluid(data);
                    improveMaterial(data);
                    improvePosition(data);
                    improveCorrosionLoop(data);
                    improveUnit(data);
                    improveProdUnit(data);
                    improveEquipment(data);
                    improveCml(data);
                } else {
                    setMaterialOptions([]);
                    setpositionOptions([]);
                    setFluid([]);
                    setUnitOptions([]);
                    setProductionUnitOptions([]);
                    setEquipmentOptions([]);
                    setcmlOptions([]);
                    setcorrosionLoopOptions([]);
                }
                setLoadingProductionUnit(false);
                setLoadingUnit(false);
                setLoadingEquipment(false);
                setLoadingCorrosionLoop(false);
                setLoadingCml(false);
                setLoadingFluid(false);
                setLoadingMaterial(false);
                setLoadingPosition(false);
            });
        }

        if (type === 'material') {
            setLoadingPosition(true);
            fetchFilterData(`nominals.material IN (${buildOptionsFilterStr(value)}) AND ${BASE_FILTER}`).then((data) => {
                if (data && data.length > 0) {
                    improvePosition(data);
                } else {
                    setpositionOptions([]);
                }
                setLoadingPosition(false);
            });
        }
        if (type === 'corrosionLoop') {
            setLoadingCml(true);
            setLoadingFluid(true);
            setLoadingMaterial(true);
            setLoadingPosition(true);
            fetchFilterData(`sensor.corrosionLoop IN (${buildOptionsFilterStr(value)}) AND ${BASE_FILTER}`).then((data) => {
                if (data && data.length > 0) {
                    improvefluid(data);
                    improveMaterial(data);
                    improvePosition(data);
                    improveCml(data);
                } else {
                    setpositionOptions([]);
                    setMaterialOptions([]);
                    setFluid([]);
                    setcmlOptions([]);
                    setcorrosionLoopOptions([]);
                }
                setLoadingCml(false);
                setLoadingFluid(false);
                setLoadingMaterial(false);
                setLoadingPosition(false);
            });
        }
    }




    const applyInitialFilter = () => {
        for (let key in filterFormValues) {
            if (filterFormValues[key].length > 0) {
                improveFilter({ type: key, value: filterFormValues[key] });
            }
        }
    }

    useEffect(() => {
        if (!noFilter) {
            applyInitialFilter();
        }
    }, [noFilter]);

    const getOptionsForFilter = (filter) => {
        switch (filter) {
            case 'site':
                return siteOptions;
            case 'productionUnit':
                return productionUnitOptions;
            case 'unit':
                return unitOptions;
            case 'equipment':
                return equipmentOptions;
            case 'fluid':
                return fluid;
            case 'material':
                return materialOptions;
            case 'position':
                return positionOptions;
            case 'cml':
                return cmlOptions;
            case 'corrosionLoop':
                return corrosionLoopOptions;
            default:
                return [];
        }
    };

    const updatedSiteValues = useUpdatedFilterValues('site', filterFormValues, getOptionsForFilter, updateFilters, noFilter);
    const updatedProdUnitValues = useUpdatedFilterValues('productionUnit', filterFormValues, getOptionsForFilter, updateFilters, noFilter);
    const updatedUnitValues = useUpdatedFilterValues('unit', filterFormValues, getOptionsForFilter, updateFilters, noFilter);
    const updatedEquipmentValues = useUpdatedFilterValues('equipment', filterFormValues, getOptionsForFilter, updateFilters, noFilter);
    const updatedFluidValues = useUpdatedFilterValues('fluid', filterFormValues, getOptionsForFilter, updateFilters, noFilter);
    const updatedMaterialValues = useUpdatedFilterValues('material', filterFormValues, getOptionsForFilter, updateFilters, noFilter);
    const updatedPositionValues = useUpdatedFilterValues('position', filterFormValues, getOptionsForFilter, updateFilters, noFilter);
    const updatedCmlValues = useUpdatedFilterValues('cml', filterFormValues, getOptionsForFilter, updateFilters, noFilter);
    const updatedCorrosionLoopValues = useUpdatedFilterValues('corrosionLoop', filterFormValues, getOptionsForFilter, updateFilters, noFilter);


    const handleApplyFilter = (e) => {

        //Clear All Filters Apply is pressed when no filter is selected
        if (!isAnyFilterSelected(filterFormValues)) {
            handleOnClear(e);
            return;
        }
        const appliedFilter = FilterSensorLogic(filterFormValues, isModel, isCancui);
        const appliedFilterWithBase = appliedFilter ? `${appliedFilter} AND ${BASE_FILTER}` : BASE_FILTER;
        const finalAppliedFilter = isCancui ? appliedFilter : appliedFilterWithBase;
        handleFilterChange(finalAppliedFilter, filterFormValues)
        console.log("applied filter on filter modal",finalAppliedFilter)
        onClose();
    };


    const handleOnClear = (e) => {
        handleFilterClear();
        updateFilters({ type: "clear", key: filterKey });
        setNoFilter(true);
        onClose();
    };


    return (
        <Modal id="filter-id-1" open={open} onClose={() => {
            updateFilters({ type: "clear", key: filterKey });
            onClose();
        }} size='medium' padding='tight' title='Filter Options' maskClosable={false}
            actions={[
                {
                    label: 'Apply',
                    action: handleApplyFilter,
                    props: {
                        disabled: !isAnyFilterSelected(filterFormValues), // disable here
                    },
                },
                {
                    label: 'Clear All',
                    action: handleOnClear,
                    props: {
                        variant: 'outlined',
                    }
                }
            ]}>

            <div className='filter-modal' id="filter-id-2">
                <Select mode='multiple' placeholder='Select Sites' label='Sites' options={siteOptions}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(_, option) => {
                        updateFilters({ type: 'site', value: option })
                        improveFilter({ type: 'site', value: option })
                    }}
                    loading={loadingSite}
                    disabled={loadingSite}
                    value={updatedSiteValues}
                    id="filter-id-3"
                />
                <Select mode='multiple' placeholder='Select Prod Units' label='Prod Units' options={productionUnitOptions}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(_, option) => {
                        updateFilters({ type: "productionUnit", value: option })
                        improveFilter({ type: "productionUnit", value: option })
                    }}
                    loading={loadingProductionUnit}
                    disabled={loadingProductionUnit}
                    value={updatedProdUnitValues}
                    id="filter-id-4"
                />
                <Select mode='multiple' placeholder='Select Units' label='Units' options={unitOptions}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(_, option) => {
                        updateFilters({ type: 'unit', value: option })
                        improveFilter({ type: 'unit', value: option })
                    }}
                    loading={loadingUnit}
                    disabled={loadingUnit}
                    value={updatedUnitValues}
                    id="filter-id-5"
                />
                <Select mode='multiple' placeholder='Select Equipments' label='Equipments' options={equipmentOptions}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(_, option) => {
                        updateFilters({ type: "equipment", value: option })
                        improveFilter({ type: "equipment", value: option })
                    }}
                    loading={loadingEquipment}
                    disabled={loadingEquipment}
                    value={updatedEquipmentValues}
                    id="filter-id-6"
                />
                {!isCancui && <Select mode='multiple' placeholder='Select Corrosion Loops' label='Corrosion Loops' options={corrosionLoopOptions}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(_, option) => {
                        updateFilters({ type: "corrosionLoop", value: option })
                        improveFilter({ type: "corrosionLoop", value: option })
                    }}
                    loading={loadingCorrosionLoop}
                    disabled={loadingCorrosionLoop}
                    value={updatedCorrosionLoopValues}
                    id="filter-id-7"
                />}
                {!isCancui && <Select mode='multiple' placeholder='Select CMLs' label='CMLs' options={cmlOptions}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(_, option) => {
                        updateFilters({ type: "cml", value: option })
                        improveFilter({ type: "cml", value: option })
                    }}
                    loading={loadingCml}
                    disabled={loadingCml}
                    value={updatedCmlValues}
                    id="filter-id-8"
                />}
                {!(isModel || isCancui) && <Select mode='multiple' placeholder='Select Fluids' label='Fluids' options={fluid}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(_, option) => {
                        updateFilters({ type: "fluid", value: option })
                        improveFilter({ type: "fluid", value: option })
                    }}
                    loading={loadingFluid}
                    disabled={loadingFluid}
                    value={updatedFluidValues}
                    id="filter-id-9"
                />}

                {!(isModel || isCancui) && <Select mode='multiple' placeholder='Select Materials' label='Materials' options={materialOptions}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(_, option) => {
                        updateFilters({ type: "material", value: option })
                        improveFilter({ type: "material", value: option })
                    }}
                    loading={loadingMaterial}
                    disabled={loadingMaterial}
                    value={updatedMaterialValues}
                    id="filter-id-10"
                />}

                {!(isModel || isCancui) && <Select mode='multiple' placeholder='Select Positions' label='Positions' options={positionOptions}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(_, option) => {
                        updateFilters({ type: "position", value: option })
                        improveFilter({ type: "position", value: option })
                    }}
                    loading={loadingPosition}
                    disabled={loadingPosition}
                    value={updatedPositionValues}
                    id="filter-id-11"
                />}
            </div>
        </Modal>
    )
}

export default FilterModal